import React from "react";
import { ChangePasswordView } from "../views/ChangePasswordView";
import { useChangePasswordVM } from "../viewmodels/ChangePasswordVM";

const ChangePasswordPage: React.FC = () => {
    const vm = useChangePasswordVM();

    return <div>
        <ChangePasswordView
            form={vm.form}
            errorMessages={vm.errorMessages}
            onValueChange={vm.setField}
            submit={vm.submit}
            loading={vm.loading}
        />
    </div>;
};

export default ChangePasswordPage;